.affectedIssuesCount {
	padding-right: 0;
}

.disabledWarningButton {
	padding: 0;
}
